import CardIcon1 from "./cards-icon-1.svg";
import CardIcon2 from "./cards-icon-2.svg";
import CardIcon3 from "./cards-icon-3.svg";
import CardIcon4 from "./cards-icon-4.svg";
import CardIcon5 from "./cards-icon-5.svg";
import CardIcon6 from "./cards-icon-6.svg";
import CardIcon7 from "./cards-icon-7.svg";
import CardIcon8 from "./cards-icon-8.svg";
import CardIcon9 from "./cards-icon-9.svg";
import CardIcon10 from "./cards-icon-10.svg";

export {
  CardIcon1,
  CardIcon2,
  CardIcon3,
  CardIcon4,
  CardIcon5,
  CardIcon6,
  CardIcon7,
  CardIcon8,
  CardIcon9,
  CardIcon10,
};
